var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9907 32.6402L27.48 67.001L41.972 32.6402C45.7455 22.1805 38.271 11.0376 27.4814 11.0376C16.6917 11.0376 9.21713 22.1805 12.9907 32.6402Z",
  fill: "#587492"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.524 32.7687L13.9656 36.1873L17.4273 44.3965L21.6147 54.3269L25.2336 62.9087C25.8189 64.2967 26.4042 65.6846 26.9894 67.0725L27.0134 67.1295C27.0777 67.3331 27.2665 67.4715 27.48 67.4715C27.6935 67.4715 27.8823 67.3331 27.9465 67.1295L29.1937 64.1725L32.2522 56.9205L36.0981 47.8017L39.7072 39.2444L42.0554 33.677C44.8729 27.1993 43.3231 19.6503 38.1813 14.8066C34.909 11.7372 30.4797 10.2147 26.0118 10.6235C21.5865 11.0733 17.5526 13.3583 14.8913 16.9225C11.4875 21.4703 10.598 27.4247 12.524 32.7688C12.7323 33.3509 13.6676 33.0999 13.4571 32.5115C11.9524 28.3573 12.2268 23.7665 14.2156 19.8211C16.1296 16.08 19.5127 13.166 23.585 12.0437C27.7875 10.8999 32.2808 11.674 35.8582 14.1584C39.2964 16.6127 41.6092 20.3413 42.2804 24.512C42.7516 27.3721 42.4139 30.3069 41.3056 32.9852L39.2868 37.7717L35.8906 45.8241L32.0815 54.8555L28.8187 62.5917L27.091 66.6882L27.0133 66.8723H27.9464L26.5049 63.4538L23.0432 55.2446L18.8557 45.3142L15.2369 36.7323C14.6517 35.3443 14.0664 33.9564 13.4811 32.5685L13.4571 32.5115C13.379 32.2594 13.1184 32.1115 12.862 32.1736C12.6054 32.246 12.4548 32.5113 12.524 32.7687Z",
  fill: "#587492"
});
var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 27.4819,
  cy: 26.9914,
  rx: 8.46043,
  ry: 8.75457,
  fill: "#F4F6F8"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M35.4576 26.9918C35.4413 30.3326 33.4349 33.5462 30.2614 34.7487C27.0546 35.9378 23.4468 34.9298 21.3207 32.2508C19.1847 29.5095 18.9167 25.7494 20.6421 22.7328C22.3309 19.8271 25.7341 18.1781 29.0574 18.8818C32.3735 19.5839 34.8404 22.3885 35.3642 25.7005C35.4279 26.128 35.4592 26.5597 35.4577 26.9919C35.4607 27.6144 36.4284 27.6157 36.4254 26.9919C36.4068 23.1914 34.1008 19.6592 30.5187 18.302C27.0103 16.9728 22.9369 18.1642 20.6105 21.0811C18.1864 24.1502 17.8763 28.3863 19.8277 31.7757C21.746 35.0648 25.5372 36.7779 29.2734 36.0437C32.9355 35.2881 35.7648 32.1215 36.3106 28.4538C36.3837 27.9698 36.422 27.4813 36.4254 26.9919C36.4283 26.369 35.4607 26.3682 35.4576 26.9918Z",
  fill: "#587492"
});
var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 28.9381,
  cy: 76.0069,
  rx: 17.065,
  ry: 2.31691,
  fill: "#194867",
  stroke: "#194867",
  strokeWidth: 0.335996
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M136.259 72.7402L134.982 81.4211L136.259 72.7402Z",
  fill: "#A8542A"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M144.212 59.8052L138.137 81.2004L144.212 59.8052Z",
  fill: "#587492"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M160.696 204.087C160.696 204.087 159.558 204.197 157.484 204.377",
  stroke: "#587492",
  strokeWidth: 1.17599,
  strokeLinecap: "round"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M151.024 204.91C118.926 207.424 17.7989 213.539 15.2219 191.024C12.1576 164.252 120.698 168.606 119.891 146.834C119.891 146.834 121.665 123.287 57.9605 129.416C11.1899 134.093 37.4111 145.868 68.4437 146.834C133.197 148.85 151.421 126.11 128.681 111.756C105.941 97.4022 42.8006 112.965 35.8656 101.676C28.9306 90.3864 71.6693 90.5478 69.4114 82.3226C68.0718 77.4426 61.396 76.3663 56.1873 76.2979",
  stroke: "#587492",
  strokeWidth: 1.17599,
  strokeLinecap: "round",
  strokeDasharray: 6.75
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M52.9461 76.3745C51.0247 76.4869 49.7363 76.6777 49.7363 76.6777",
  stroke: "#587492",
  strokeWidth: 1.17599,
  strokeLinecap: "round"
});
var _ref12 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_876_5192)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M163.064 200.246L166.612 188.19L169.167 187.463L168.848 198.601L175.695 196.653L176.733 192.215L178.649 191.67L179.007 197.782L181.92 203.167L180.004 203.712L176.784 200.485L169.937 202.433L176.072 211.735L173.517 212.462L164.155 204.078L157.196 206.058C156.688 206.202 156.143 206.139 155.682 205.882C155.22 205.625 154.88 205.195 154.735 204.687C154.59 204.179 154.654 203.634 154.911 203.172C155.168 202.711 155.598 202.37 156.106 202.225L163.064 200.246Z",
  fill: "#587492"
}));
var _ref13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_876_5192"
}, /*#__PURE__*/React.createElement("rect", {
  width: 31.876,
  height: 31.876,
  fill: "white",
  transform: "translate(156.723 221.382) rotate(-105.88)"
})));
function SvgCampaign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 222,
    viewBox: "0 0 191 222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/campaign.68317ff69c5139b0805d68bcc989b2ce.svg";
export { ForwardRef as ReactComponent };